// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectedContainerWraperLeft {
    flex-grow: 2;
    width: 30em;
}

.SelectedContainerWraperRight {
    flex-grow: 2;
    text-align: center;
    width: 20em;
}

.SelectedContainerWraper {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.ImageTextLoaderText {
    border-radius: 5px;
    padding: 1em;
    border: 2px solid var(--templatesColorBackgroundInContainer);
    max-width: 50em;
    cursor: pointer;
}

.ImageTextLoaderText:hover {
    background-color: var(--templatesColorTextInContainer);
}

.ImageLoaderImageSelectDisplay {
    display: block;
    max-height: 90px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}

.selectedTemplatesDisplayTextForNoImagesSelected {
    display: flex;
    justify-content: center;
}

.selectedimagesCardContainerDisplayButtonsEdit {
    display: flex;
    gap: 2em;
}

.selectedTemplatesDisplayContainerElements {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: auto;
    gap: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Templates/Selected/Selected.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,4DAA4D;IAC5D,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,QAAQ;AACZ","sourcesContent":[".SelectedContainerWraperLeft {\n    flex-grow: 2;\n    width: 30em;\n}\n\n.SelectedContainerWraperRight {\n    flex-grow: 2;\n    text-align: center;\n    width: 20em;\n}\n\n.SelectedContainerWraper {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.ImageTextLoaderText {\n    border-radius: 5px;\n    padding: 1em;\n    border: 2px solid var(--templatesColorBackgroundInContainer);\n    max-width: 50em;\n    cursor: pointer;\n}\n\n.ImageTextLoaderText:hover {\n    background-color: var(--templatesColorTextInContainer);\n}\n\n.ImageLoaderImageSelectDisplay {\n    display: block;\n    max-height: 90px;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n}\n\n.selectedTemplatesDisplayTextForNoImagesSelected {\n    display: flex;\n    justify-content: center;\n}\n\n.selectedimagesCardContainerDisplayButtonsEdit {\n    display: flex;\n    gap: 2em;\n}\n\n.selectedTemplatesDisplayContainerElements {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    height: auto;\n    gap: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
